var render, staticRenderFns
import script from "./user_group_callout_dismisser.vue?vue&type=script&lang=js&vue3"
export * from "./user_group_callout_dismisser.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports